import { useEffect, useRef } from "react";
import { useRouter } from "next/router";
import { GE_CHECKOUT_PATH } from "@/libs/global-e/checkout-marker";
import {
  clearCartIfConsumed,
  watchConsumedCartOnPageLoad,
} from "@/libs/global-e/consumed-cart";

/** 카트 페이지. 카트 시트는 폐지됐다 — 카트를 보는 표면은 이 페이지뿐이다(`showCart()` = `/cart` 이동). */
export const CART_PAGE_PATH = "/cart";

// GE 주문으로 소비된 카트를 페이지 로드·카트 페이지 이동 때 회수한다. docs/global-e-storefront.md §4.7.3.
// 표식(`checkout-marker.ts`)이 없으면 아무것도 묻지 않는다 — GE 결제를 시작한 적 없는 브라우저는 요청 0회.
export function GeConsumedCartWatcher() {
  const router = useRouter();
  const mounted = useRef(false);

  // 페이지 로드. GE 복귀는 full-nav 라 앱이 새로 마운트된다 → 마운트 시점 pathname 만 본다(CartLoginSync 와 같은 전제).
  // GE 체크아웃 페이지에서는 묻지 않는다 — 거기서 비우는 건 CONFIRMATION 콜백 몫이고, 결제 도중 폴링은 낭비다.
  useEffect(() => {
    if (router.pathname === GE_CHECKOUT_PATH) return;
    const ctrl = new AbortController();
    void watchConsumedCartOnPageLoad(ctrl.signal);
    return () => ctrl.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 카트 페이지로 **SPA 이동**할 때 1회 — 복귀 뒤 페이지 안에서만 돌아다닌 사용자가 남은 카트를 보는 시점이다.
  // 마운트 때는 건너뛴다(위 효과가 이미 묻는다). ⚠️ `isCartOpen` 을 트리거로 쓰지 말 것 — 시트 폐지 후 죽은 플래그라
  // 담기(`add()`)마다 true 가 되고 persist 된다(방금 담은 아이템까지 회수에 휘말린다).
  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      return;
    }
    if (router.pathname === CART_PAGE_PATH) void clearCartIfConsumed();
  }, [router.pathname]);

  return null;
}
